import Axios from '@/components/api/axios.js'
/**********************************************************************************
 * 实时数据
 **********************************************************************************/
export default {
	/**
	 * 设备遥控
	 */
	deviceOperation: (group, operation, timeout, success, failure) => {
		Axios.post('/webSocket/deviceOperation.do', {
			group,
			operation,
			timeout
		}, success, failure);
	},
	/**
	 * 空调遥控
	 */
	airConditionerOperation: (group, operation, timeout, setTemperature, runModel, windSpeed, windHorizontal, windVertical,
		success, failure) => {
		Axios.post('/webSocket/airConditionerOperation.do', {
			group,
			operation,
			timeout,
			setTemperature,
			runModel,
			windSpeed,
			windHorizontal,
			windVertical
		}, success, failure);
	},
	/**
	 * 空调权限
	 */
	airConditionerRight: (group, operation, timeout, lowTemperature, highTemperature, runModels, windSpeeds,
		windHorizontal, windVertical,
		success, failure) => {
		Axios.post('/webSocket/airConditionerRight.do', {
			group,
			operation,
			timeout,
			lowTemperature,
			highTemperature,
			runModels,
			windSpeeds,
			windHorizontal,
			windVertical
		}, success, failure);
	},
	/**
	 * 组播
	 */
	airConditionerQueueGroup: (pkid, success, failure) => {
		Axios.post('/webSocket/airConditionerQueueGroup.do', {
			pkid
		}, success, failure);
	},
	airConditionerQueueGroupRight: (pkid, timeout, lowTemperature, highTemperature, runModels, windSpeeds,
		windHorizontal, windVertical,
		success, failure) => {
		Axios.post('/webSocket/airConditionerQueueGroupRight.do', {
			pkid,
			timeout,
			lowTemperature,
			highTemperature,
			runModels,
			windSpeeds,
			windHorizontal,
			windVertical
		}, success, failure);
	},
	airConditionerQueueGroupOperation: (pkid, timeout, setTemperature, runModel, windSpeed, windHorizontal, windVertical,
		success, failure) => {
		Axios.post('/webSocket/airConditionerQueueGroupOperation.do', {
			pkid,
			timeout,
			setTemperature,
			runModel,
			windSpeed,
			windHorizontal,
			windVertical
		}, success, failure);
	},
	/**
	 * 通用遥控变量写值接口
	 */
	writeVariableValue: (variableName, value, timeOut, success, failure) => {
		Axios.post('/webSocket/writeVariableValue.do', {
			variableName, value, timeOut,
		}, success, failure);
	},
}
